// Nom de l'edge function de chat.
//
// Rendu configurable pour pouvoir recetter une version migree (ex.
// `v0-chat-next`, en Claude Opus 5.5) sur un apercu, sans jamais toucher a la
// fonction `v0-chat` en ligne ni a la production.
//
// Non defini => `v0-chat`, le comportement historique.
export const CHAT_FUNCTION =
  (import.meta.env.VITE_CHAT_FUNCTION as string | undefined)?.trim() || 'v0-chat';

// Nom de l'edge function d'integrations (deploiement Vercel, Supabase,
// GitHub, Netlify).
//
// Rendu configurable pour la meme raison que le chat : pouvoir recetter une
// version corrigee (`integrations-next`) sur un apercu, sans jamais toucher
// la fonction `integrations` en ligne.
//
// Non defini => `integrations`, le comportement historique.
export const INTEGRATIONS_FUNCTION =
  (import.meta.env.VITE_INTEGRATIONS_FUNCTION as string | undefined)?.trim() || 'integrations';
